import axios from "axios";

export const getNotifications = async (host) => {
  const url = `https://${host}/dashboard/notifications`;
  try {
    const response = await axios.get(url)
    return response;
  } catch(err) {
    console.error(err);
  }
}

export const getNotificationCount = async (params) => {
  const url = (params.user === "admin") ? `https://${params.host}/admin/dashboard/notification_count` : `https://${params.host}/dashboard/notification_count`;
  try {
    const response = await axios.get(url)
    return response;
  } catch(err) {
    console.error(err);
  }
}

export const readPostNotification = async (params) => {
  
  const url = `https://${params.host}/dashboard/read_notification`;
  try {
    const response = await axios.post(url, params.formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    return response;
  } catch(err) {
    console.error(err);
  }
}

export const clearNotificationCount = async (host) => {
  const url = `https://${host}/dashboard/clear_notification`
  try {
    const response = await axios.get(url)
    return response;
  } catch(err) {
    console.error(err);
  }
}

export const verifyMailProcess = async (host) => {
  const url = `https://${host}/api/sendVerificationMail`
  try {
    const response = await axios.get(url)
    return response;
  } catch(err) {
    console.error(err);
  }
}
